import firebase from 'firebase'
import 'firebase/firestore'

const config = {
    apiKey: 'AIzaSyBfSbedWxxQy1qbEp1m_gTBEA5ICsirKDQ',
    authDomain: 'circa-jewels-sandbox-e8b71.firebaseapp.com',
    databaseURL: 'https://circa-jewels-sandbox-e8b71.firebaseio.com',
    projectId: 'circa-jewels-sandbox-e8b71'
}

const firebaseApp = firebase.initializeApp(config)

const firestore = firebaseApp.firestore()
//firestore.settings({ timestampsInSnapshots: true })

//export default firestore
export default firebase.firestore(firebaseApp)


// WEBPACK FOOTER //
// ./src/firebase.js